import Vue from 'vue'
import App from './App.vue'

import router from './router'

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'

firebase.initializeApp({
  apiKey: 'AIzaSyCv9Dkb2J9_eBd6W1xV-YCzN_UwjrKt5Qg',
  authDomain: 'prepsxsteps.firebaseapp.com',
  databaseURL: 'https://prepsxsteps.firebaseio.com',
  projectId: 'prepsxsteps',
  storageBucket: 'prepsxsteps.appspot.com',
  messagingSenderId: '528885920240',
  appId: '1:528885920240:web:cafe90969540bcdf',
  measurementId: 'G-EBHX9DYEZX',
})

firebase.analytics()

Vue.prototype.db = firebase.firestore()
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
